import React from "react";
import { format } from "date-fns";
import style from "../woundAssessment.module.scss";
import LogoImage from "../../../../static/images/measurmenttest.jpg";
import PDFIcon from "../../../../static/images/pdfIcon.svg";
import { trendConfig } from "../trendConfig";
import { ThreeDotMenu } from "./ThreeDotMenu";

export const AssessmentRow = ({
  history,
  index,
  woundTitle,
  isConsolidatedPdfEnable,
  selectedIdsByWound,
  parentIndex,
  handleSelectOne,
  woundProgress,
  assessmentStageGetter,
  detaileView,
  pdfmodalopen,
  setHistoryId,
  hasAccess,
  clickThreeDots,
  openTooltip,
  threeDotPanelClick,
  threeDotMenuProps,
}) => {
  const { color: trendColor, icon: trendIcon, name: trendName } = trendConfig[history?.trendChangeMetricDetail?.status] || trendConfig.default;

  return (
    <tr className={`${style.complete_td} mb-2`}>
      {isConsolidatedPdfEnable === 1 && (
        <td className={style.tr_space}>
          <input
            type="checkbox"
            className={style.consolidate_checkbox}
            checked={selectedIdsByWound[parentIndex]?.includes(history.id) || false}
            onClick={() => handleSelectOne(parentIndex, history.id)}
            disabled={history.assessmentStage !== "signedlocked"}
          />
        </td>
      )}
      <td className={style.tr_space} onClick={() => detaileView(history.id)}>
        {history.picture ? (
          <img src={history.picture} alt="wound" className={style.modal_image} />
        ) : (
          <img src={LogoImage} alt="wound" className={style.modal_image} />
        )}
      </td>
      <td className={style.tr_space} onClick={() => detaileView(history.id)}>
        {history.recordType ? <span className={`${style.recordTypeBatch}`}>{history.recordType}</span> : "-"}
      </td>
      <td className={style.tr_space} onClick={() => detaileView(history.id)}>
        {format(new Date(history.identifiedDate), "LLLL d, yyyy hh:mmaa")}
      </td>
      <td className={style.tr_space} onClick={() => detaileView(history.id)}>
        {history?.woundStage ? woundProgress?.find((data) => data.key === history.woundStage.toLowerCase())?.value || "" : ""}
      </td>
      <td className={style.tr_space} onClick={() => detaileView(history.id)}>
        <span style={{ color: trendColor }}>
          <i className={`${trendIcon} mr-2`} />
          {trendName}
        </span>
      </td>
      <td className={style.tr_space} onClick={() => detaileView(history.id)}>
        {assessmentStageGetter(history.assessmentStage)}
      </td>
      <td className={style.tr_space} onClick={() => detaileView(history.id)}>
        {history.refusalReason ? <span className={`${style.recordTypeBadge} ${style.typeReval}`}>{history.refusalReason}</span> : "-"}
      </td>
      <td className={style.tr_space} key={index}>
        {history.assessmentStage === "pendingreview" || history.assessmentStage === "signedlocked" ? (
          <span
            className={`${style.pdf_link} pl-5`}
            onClick={() => {
              pdfmodalopen();
              setHistoryId(history.id);
            }}
          >
            <img
              src={PDFIcon}
              alt="pdfIcon"
              onClick={() => {
                pdfmodalopen();
                setHistoryId(history.id);
              }}
            />
          </span>
        ) : (
          "-"
        )}
      </td>
      {hasAccess && (
        <td className={style.tr_space}>
          <div className={`${style.Three_Dots_Panel_History}`} onClick={() => threeDotPanelClick(history.id)}>
            <i
              className="fa fa-ellipsis-v"
              style={history.id !== clickThreeDots ? { color: "#464646" } : { color: "#919191" }}
              aria-hidden="true"
            ></i>
            {openTooltip && history.id === clickThreeDots && <ThreeDotMenu history={history} woundTitle={woundTitle} {...threeDotMenuProps} />}
          </div>
        </td>
      )}
    </tr>
  );
};
